import React from "react";
import { Box, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const SearchBar = ({ searchQuery, onSearchChange, searchResults }) => {
  return (
    <Box sx={{ 
      px: { xs: 1.25, sm: 2.5, md: 6 },
      py: { xs: 1.5, sm: 2, md: 2.5 },
    }}>
      <Box sx={{ 
        position: "relative",
        maxWidth: { xs: "100%", sm: 550, md: 750 },
        mx: "auto"
      }}>
        <Box sx={{
          display: "flex",
          alignItems: "center",
          bgcolor: "#fff",
          borderRadius: { xs: 2.5, sm: 3, md: 3.5 },
          boxShadow: "0 3px 12px rgba(255, 179, 0, 0.12)",
          border: "2px solid #ffe0b2",
          px: { xs: 1.5, sm: 2 },
          py: { xs: 0.875, sm: 1, md: 1.125 },
          transition: "all 0.2s",
          "&:focus-within": {
            borderColor: "#ffb300",
            boxShadow: "0 4px 16px rgba(255, 179, 0, 0.2)",
          }
        }}>
          <SearchIcon sx={{ 
            color: "#ffb300", 
            fontSize: { xs: 22, sm: 26, md: 28 },
            mr: { xs: 0.75, sm: 1 },
            flexShrink: 0,
          }} />
          <input
            type="text"
            placeholder="ابحث عن منتج..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            style={{
              flex: 1,
              border: "none",
              outline: "none",
              fontSize: window.innerWidth < 600 ? "13px" : "15px",
              fontFamily: "Cairo, Arial, sans-serif",
              backgroundColor: "transparent",
              color: "#222",
              minWidth: 0,
            }}
          />
          {searchQuery && (
            <IconButton
              onClick={() => onSearchChange("")}
              size="small"
              sx={{ 
                color: "#ff3d3d",
                p: { xs: 0.5, sm: 0.75 },
                ml: { xs: 0.5, sm: 0.75 },
                "&:hover": { 
                  bgcolor: "#fff3f3",
                  transform: "scale(1.1)",
                },
                transition: "all 0.2s",
              }}
            >
              <ClearIcon sx={{ fontSize: { xs: 18, sm: 22 } }} />
            </IconButton>
          )}
        </Box>
        {searchQuery && (
          <Box sx={{ 
            mt: 0.75, 
            textAlign: "center", 
            color: "#888",
            fontSize: { xs: 11, sm: 12 },
            fontWeight: 500,
          }}>
            {searchResults ? `✨ ${searchResults.totalProducts} منتج` : "❌ لا توجد نتائج"}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SearchBar;
